import { render, staticRenderFns } from "./CrmFileEvent.vue?vue&type=template&id=0feba985"
import script from "./CrmFileEvent.vue?vue&type=script&lang=ts"
export * from "./CrmFileEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0feba985')) {
      api.createRecord('0feba985', component.options)
    } else {
      api.reload('0feba985', component.options)
    }
    module.hot.accept("./CrmFileEvent.vue?vue&type=template&id=0feba985", function () {
      api.rerender('0feba985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/events/CrmFileEvent.vue"
export default component.exports